<!-- ----------------------------------------------- -->
<template>
  <div class="legend-content">
    <v-container>
      <v-row class="ma-0" v-for="(item, i) in tmIcon" :key="i">
        <v-col :cols="3" class="pa-0 tm-img">
          <img :src="item.img" style="height: 33px;" />
        </v-col>
        <v-col :cols="9" class="pa-2 pt-1">
          <span class="tm-text" style="white-space:nowrap">
            {{ item.name }}
          </span>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 地図画面 地図凡例ダイアログ 観測所種別
 * LegendTmKnd.vue
 * @author LIS
 */
export default {
  name: "legend-tm-knd",
  data() {
    return {
      tmIcon: [
        {
          img: "/kawabou/img/obs_icons/obs_water.svg",
          name: "水位観測",
        },
        {
          img: "/kawabou/img/obs_icons/obs_swstg.svg",
          name: this.$store.state.app.config.replaceNameConfig.swstg,
        },
        {
          img: "/kawabou/img/obs_icons/obs_dam.svg",
          name: "ダム諸量",
        },
        {
          img: "/kawabou/img/obs_icons/obs_rain.svg",
          name: "雨量",
        },
        {
          img: "/kawabou/img/obs_icons/obs_quality.svg",
          name: "水質",
        },
        {
          img: "/kawabou/img/obs_icons/obs_sea.svg",
          name: "海岸",
        },
        {
          img: "/kawabou/img/obs_icons/obs_snow.svg",
          name: "積雪深",
        },
        {
          img: "/kawabou/img/obs_icons/obs_camera.svg",
          name: "河川カメラ",
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.legend-content {
  width: 180px;
  .tm-img {
    display: flex;
    justify-content: center;
  }
  .tm-text {
    font-size: 0.9rem;
    color: black;
  }
}
</style>
